'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reduxImmutable = require('redux-immutable');

var _deepChildrenModCacheReducer = require('./deepChildrenModCacheReducer');

var _deepChildrenModCacheReducer2 = _interopRequireDefault(_deepChildrenModCacheReducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Lib
exports.default = (0, _reduxImmutable.combineReducers)({
    deepChildrenMod: _deepChildrenModCacheReducer2.default
});


//////////////////
// WEBPACK FOOTER
// ./src/client/element/cache/index.js
// module id = 1959
// module chunks = 0